import axios from 'axios';
import { API_BASE_URL, AUTH_TOKEN_KEY } from '../../../constants';

export function useDeleteRecentSearch(id?: number) {
  if (!id) {
    return axios
      .delete(`${API_BASE_URL}/products/recent/search`, {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY),
        },
      })
      .then((res) => res)
      .catch((err) => {
        throw err;
      });
  }

  return axios
    .delete(`${API_BASE_URL}/products/recent/search`, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY),
      },
      data: {
        searches_id: id,
      },
    })
    .then((res) => res)
    .catch((err) => {
      throw err;
    });
}
